import React, { useState, useContext } from "react";
import styled from "styled-components";
import * as FileSaver from 'file-saver';
import XLSX from  'sheetjs-style';
import ShowImageSettings from "../utils/showImageSettings";

export default function Table ( {title, data, fileName, colours, textColours, isCell=0}  ) {  
    const settings = useContext(ShowImageSettings);  
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let values = [];
    let keys = Object.keys(data);;
    let newData = [];
    let rowIsActive = []
    if (keys.length) {        
        values = data[keys[0]];
        for (let i=0; i<values.length; i++) {
            let temp = {};
            for (let j=0; j<keys.length; j++) {
                temp[keys[j]] = data[keys[j]][i];
            }
            newData = [...newData, temp];
            rowIsActive = [...rowIsActive, false];
        }
    }
    rowIsActive[0] = true;
    const [active, setActive] = useState(rowIsActive)   
    
    const handleColorChange = (event) => { 
        if (!isCell) {
            const id = event.currentTarget.getAttribute("data-rowid");   
            setActive((prevState) => {
                return prevState.map((item, index) => {
                if(index === Number(id)) {                
                    return !item;
                }else {
                    if (item) {
                        return !item;
                    }
                    return item;
                }
                })
            })
            settings.updateImageSettings(id);
        }
    }

    const handleDownload = async () => {
        console.log(fileName + '.xlsx')
        const ws = XLSX.utils.json_to_sheet(newData);
        const wb = { Sheets: {'data': ws}, 'SheetNames': ['data']};
        const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
        const data_download = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data_download, fileName + '.xlsx');
    }

return (
    <Container>
        <div className="sub-heading">
            <h3> {title} </h3>
            {!isCell && (
                <h5> Click on a row to visualise a defect. </h5>
            )}
        </div>
        <STable>
            <STHead>
                <STHeadTR>
                    {keys.map((item, index) => (  // ["#", ...keys]
                        <STH key={index} style={{fontWeight: "bold"}}>{item}</STH>
                    ))}
                </STHeadTR>
            </STHead>
            <STBody>
                {newData.map((obj, index) => (
                    <STBodyTR key={index} data-rowid={index}  style={active[index] ? {backgroundColor: '#CAD4D1'} : {backgroundColor: 'white'}} onClick={handleColorChange}  >  
                        {keys.map((item, i) => {
                            const value = obj[item];
                            return <STD  key={i}
                            style={i === 1 ? {backgroundColor: `rgb(${colours[index]})`, color: `${textColours[index]}`}  : {backgroundColor:"0"} } >   
                                {value}</STD>;
                                //{i === 0 ? { fontWeight: "bold"} : { fontWeight: "normal"}} >
                        })}
                    </STBodyTR>
                ))}
            </STBody>
        </STable>
    <BTN>
    <button onClick={handleDownload}> Download </button>
    </BTN>
    </Container>
);
}

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .sub-heading {
        padding: 0.5rem;
    }
`;

export const STable = styled.table`
    width: 100%;
    border-collapse: collapse;
    text-align: center;
    overflow: hidden;
    align-items: center;
    justify-content: center;        
    box-shadow: rgba(0, 0, 0, 0.75) 0px 3px 10px;
    border-radius: 5px;
`;

export const STHead = styled.thead`        
    z-index: 100;
`;

export const STHeadTR = styled.tr`
    background: #efefef;
`;

export const STH = styled.th`
    font-weight: normal;
    padding: 1rem;
    color: black;
    text-transform: capitalize;
    font-weight: 600;
    font-size: 12px;
`;

export const STBody = styled.tbody``;

// background: white;  background-color: ${props => (props.key == rowSelected ? '#CAD4D1' : 'white')} ${({ props }) => (props.isSelected ? "background-color: #CAD4D1" : "background-color: white")} 
export const STBodyTR = styled.tr`    
    &:hover {
        cursor: pointer;
        background-color: #CAD4D1;
    }     
`;

export const STD = styled.td`
    padding: 0.3rem;
    font-size: 12px;
`;

export const BTN = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;    
    padding: 1rem;
    button {
        padding: 0.5rem 1rem;
        background-color: #E55B41;
        border: none;
        cursor: pointer;
        color: white;
        border-radius: 0.2rem;
        font-weight: bolder;
        font-size: 1.05rem;
    }
`;

// :not(:last-of-type) {
//     border-right: 1px solid black;
// }
// :first-of-type {
//     width: 1%;
//     white-space: nowrap;
// }